// extracted by mini-css-extract-plugin
export default {"sessions__time":"Sessions_sessions__time__l7avW","sessions__time_empty":"Sessions_sessions__time_empty__NSGnN"};